import { Navbar, Nav, Container } from 'react-bootstrap';
import { generatePath, useLocation } from "react-router";

import styles from './Navigation.module.css';

function Navigation() {
  let location = useLocation()

  return (
    <Navbar expand="lg" data-bs-theme="dark" sticky="top" className={styles.Navigation}>
      <Container>
        <Navbar.Brand href="/" className={styles.Brand}>
          <span className={styles.BrandTownsville}>Townsville</span>
          <span className={styles.BrandToday}>.Today</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav className="me-auto" activeKey={location.pathname}>
            <Nav.Link href={generatePath('/rivers/ross')}>Ross River</Nav.Link>
            <Nav.Link href={generatePath('/rivers/bohle')}>Bohle River</Nav.Link>
            <Nav.Link href={generatePath('/rivers/black')}>Black River</Nav.Link>
            <Nav.Link href={generatePath('/rivers/alligator')}>Alligator Creek</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation
